module.exports = __webpack_public_path__ + "img/3.cac78283.jpg";